// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"54fcc997","403":"01ee93c1"}[chunkId] + ".chunk.css";
};